import React from "react";
import Forbidden from "../../components/pages/Forbidden";
import { SelectOrganizationPage } from "../../components/pages/SelectOrganization/SelectOrganizationPage";
import { SideMenu } from "../../components/utils/SideMenu/SideMenu.container";
import {
  ISideMenuArrow,
  SideMenuArrowContext,
  SideMenuCloseArrow,
} from "../../components/utils/SideMenu/SideMenuCloseArrow";
import Spinner from "../../components/utils/Spinner";
import SubTopbar from "../../components/utils/SubTopbar";
import TopBar from "../../components/utils/TopBar";
import { IOrganization } from "../../reducers/course-author/types";
import { FetchAllOrganizationsRequestState } from "./reducer";
import { ISelectOrganizationProps } from "./types";

export const SelectOrganizationComponent = (props: ISelectOrganizationProps) => {
  const {
    authenticationState: { isKnown, isAuthenticated },
    isAdmin,
    organizationName,
    userName,
    fetchAllOrganizationsRequestState,
  } = props;
  const [menuExpanded, setMenuExpanded] = React.useState(false);
  const loading =
    !isKnown || !isAdmin || fetchAllOrganizationsRequestState !== FetchAllOrganizationsRequestState.SUCCEEDED;
  const { isOpen } = React.useContext<ISideMenuArrow>(SideMenuArrowContext);
  const childrenLookup = buildChildrenMap(props.organizations);

  React.useEffect(() => {
    props.mount();
    return props.unmount;
  }, []);

  if (loading) {
    return <Spinner />;
  }

  if (!isAuthenticated) {
    return <Forbidden />;
  }

  const onToggleMenuClick = () => setMenuExpanded(!menuExpanded);

  return (
    <>
      <TopBar showToggleMenu={true} onToggleMenuClick={onToggleMenuClick} userName={props.userName} />
      <SideMenuCloseArrow />
      <SideMenu
        expanded={menuExpanded}
        organizationName={organizationName}
        userName={userName}
        onClose={onToggleMenuClick}
        isOpen={isOpen}
      />
      <SubTopbar withSidebar={true} isOpen={isOpen}>
        {props.selectedOrganization && (
          <SelectOrganizationPage
            onOrganizationClick={props.selectOrganization}
            selectedOrganization={props.selectedOrganization}
            organizations={props.organizations}
            childrenLookup={childrenLookup}
          />
        )}
      </SubTopbar>
    </>
  );
};

function buildChildrenMap(
  source: IOrganization[]
): {
  [k: string]: IOrganization[];
} {
  return source.reduce((byOwner: { [k: string]: IOrganization[] }, org: IOrganization) => {
    if (org.ownerOrganizationId === org.organizationId) {
      return byOwner;
    } else if (byOwner[org.ownerOrganizationId] === undefined) {
      return { ...byOwner, [org.ownerOrganizationId]: [org] };
    } else {
      return {
        ...byOwner,
        [org.ownerOrganizationId]: [...byOwner[org.ownerOrganizationId], org],
      };
    }
  }, {});
}
